import React, { useState } from "react";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Header.css";

export default function Header() {
  const [showHeaderOptions, setShowHeaderOptions] = useState(false);

  return (
    <div>
      <div className="header-container" id="home">
        <div className="header-parent">
          <div className="header-hamburger">
            <FontAwesomeIcon className="header-humburger-bars" icon={faBars} />
          </div>
          <div className="header-logo">
            <span>Hello World!</span>
          </div>
          <div
            className={
              showHeaderOptions
                ? "header-options show-hamburger-options"
                : "header-options"
            }
          >
            <a href="#home">Home</a>
            <a href="#aboutMe">AboutMe</a>
            <a href="#resume">Resume</a>
            <a href="#contactMe">Contact Me</a>
          </div>
        </div>
      </div>
    </div>
  );
}
